








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ContinueShopping extends Vue {
  @Prop({ required: true })
  readonly urlToContinueShopping: string
}
